import { render, staticRenderFns } from "./DistritoTypeAhead.vue?vue&type=template&id=2110840f"
import script from "./DistritoTypeAhead.vue?vue&type=script&lang=js"
export * from "./DistritoTypeAhead.vue?vue&type=script&lang=js"
import style0 from "./DistritoTypeAhead.vue?vue&type=style&index=0&id=2110840f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports